import { Modal } from '@/components/ui/Modal';
import { useT } from '@/store/i18n';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function ShortcutsHelp({ open, onClose }: Props) {
  const t = useT();

  const SHORTCUTS = [
    { group: t('shortcuts.group.general'), items: [
      { combo: ['Ctrl', 'K'], desc: t('shortcuts.open_palette') },
      { combo: ['Shift', '?'], desc: t('shortcuts.show_shortcuts') },
      { combo: ['Esc'], desc: t('shortcuts.close_modal') },
    ]},
    { group: t('shortcuts.group.nav'), items: [
      { combo: ['G', 'D'], desc: t('shortcuts.go_dashboard') },
      { combo: ['G', 'Q'], desc: t('shortcuts.go_questions') },
      { combo: ['G', 'B'], desc: t('shortcuts.go_bank') },
      { combo: ['G', 'A'], desc: t('shortcuts.go_approvals') },
    ]},
    { group: t('shortcuts.group.actions'), items: [
      { combo: ['N'], desc: t('shortcuts.create_question') },
      { combo: ['/'], desc: t('shortcuts.focus_search') },
    ]},
  ];

  return (
    <Modal open={open} onClose={onClose} title={t('shortcuts.title')} size="md">
      <div className="space-y-5">
        {SHORTCUTS.map((g) => (
          <div key={g.group}>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">
              {g.group}
            </h4>
            <ul className="space-y-1.5">
              {g.items.map((s, i) => (
                <li key={i} className="flex items-center justify-between py-1.5 px-3 rounded-md hover:bg-slate-50">
                  <span className="text-sm text-slate-700">{s.desc}</span>
                  <span className="flex items-center gap-1">
                    {s.combo.map((k, j) => (
                      <kbd
                        key={j}
                        className="px-2 py-0.5 bg-slate-100 border border-slate-200 rounded text-[11px] font-mono text-slate-700"
                      >
                        {k}
                      </kbd>
                    ))}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Modal>
  );
}
